import React, { useEffect } from "react";
import SwProjectList from "../components/swProjectList";
import SiteProjectHeader from "../components/siteProjectHeader";
import {
  ADMIN_ADD_SITE,
  ADMIN_SITE_PROJECTS_LIST,
  ADMIN_PROJECTS_LIST,
  ADMIN_ADD_STORM_WATERPROJECT,
  ACCESS_DENIED,
  ADMIN_SW_VIEW_PROJECT,
} from "../../../../constant/routeContant";
import { useDispatch, useSelector } from "react-redux";
import * as swprojectAction from "../../../../redux/storm-water/actions/projectAction";
import { PAGE_SIZE, ORG_ID, LOGIN_ORG_ID } from "../../../../constant/constant";
import { checkPrivileges } from "../../../../utils/rolesHelper";
import * as clientAction from "../../../../redux/actions/clientAction";
import * as siteAction from "../../../../redux/storm-water/actions/siteAction";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Loader from "../../../../library/common/Loader";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getPreviousRoute } from "../../../../utils/routeTracker";
import * as projectAction from "../../../../redux/storm-water/actions/projectAction";

function SwProjectListContainer({ isShow = true }) {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const divisionId = location?.state?.divisionId;
  const [shouldRestoreState, setShouldRestoreState] = useState(false);
  const dataHeader = {
    title: LOGIN_ORG_ID() == 1 ? "Sites and Projects" : "Projects",
    btnLink: ADMIN_ADD_STORM_WATERPROJECT,
    menu: [
      {
        route: ADMIN_SITE_PROJECTS_LIST,
        text: "Sites",
        isshow: checkPrivileges([12, 108, 109, 110]),
      },
      {
        route: ADMIN_PROJECTS_LIST,
        text: "Projects",
        isshow: checkPrivileges([12, 111, 112, 113]),
      },
    ],
  };
  if (checkPrivileges([12, 111, 112])) {
    dataHeader.btnText = "Add Project";
  }
  // LOGIN_ORG_ID() == 1 &&
  //   checkPrivileges([12, 108, 109, 110]) &&
  //   dataHeader.menu.unshift({
  //     route: ADMIN_SITE_PROJECTS_LIST,
  //     text: "Sites",
  //   });

  const swprojectListData = useSelector((state) => state?.swprojectList);

  const swProjectList = (data) => {
    dispatch(swprojectAction.swProjectList(data));
    dispatch(swprojectAction.getProjectFilterObj(data));
  };
  const defaultData = {
    page: 1,
    pageSize: PAGE_SIZE,
    customerId: ORG_ID() == 1 ? 0 : ORG_ID(),
    startDate: "",
    endDate: "",
    search: "",
    siteId: "",
    status: "",
    divisionId: divisionId ?? "",
  };

  useEffect(() => {
    const previousRoute = getPreviousRoute();
    const preserveRoutes = [
      ADMIN_PROJECTS_LIST,
      ADMIN_ADD_STORM_WATERPROJECT,
      ADMIN_SW_VIEW_PROJECT,
    ];
    const isFromPreserveRoute =
      previousRoute &&
      preserveRoutes.some((r) => previousRoute.startsWith(r)) &&
      sessionStorage.getItem("swProjectListPreserveState") === "true";
    sessionStorage.removeItem("swProjectListPreserveState");

    dispatch(swprojectAction.clearsWProject());
    dispatch(swprojectAction.clearsWProjectUpdate());
    if (isFromPreserveRoute && swprojectListData?.filterObj) {
      setShouldRestoreState(true);
      swProjectList(swprojectListData.filterObj);
    } else {
      setShouldRestoreState(false);
      swProjectList(defaultData);
    }
  }, []);
  const searchAllClientsReducerData = useSelector(
    (state) => state.searchAllClientsReducerData,
  );
  const autoSearchDataLoading = searchAllClientsReducerData.isLoading;
  const searchSitedata = useSelector(
    (state) => state?.siteListAutoSearch?.data,
  );
  const searchClient = (searchText) => {
    dispatch(clientAction.searchAllClients(searchText));
  };
  const searchSite = (searchText) => {
    dispatch(siteAction.getSiteAutoSearchList(searchText));
  };

  const deleteProjectData = useSelector((state) => state.deleteSWProject);

  const deleteSWProject = (projectId) => {
    dispatch(swprojectAction.deleteProject(projectId));
  };

  useEffect(() => {
    if (deleteProjectData.status === 200) {
      if (swprojectListData?.filterObj) {
        swProjectList(swprojectListData.filterObj);
      } else {
        swProjectList(defaultData);
      }
    }
  }, [deleteProjectData]);

  const isLoading = swprojectListData?.isLoading;

  useEffect(() => {
    dispatch(projectAction.getProjectDetailsReset());
  }, [location.pathname]);

  return (
    <>
      {checkPrivileges([111, 112, 113, 12, 108, 109, 110]) ? (
        <>
          {isShow && <SiteProjectHeader dataHeader={dataHeader} />}

          <SwProjectList
            swProjectLists={swProjectList}
            swProjectListData={swprojectListData}
            isLoading={isLoading}
            searchClient={searchClient}
            autoSearchDataLoading={autoSearchDataLoading}
            searchAllClientsReducerData={searchAllClientsReducerData}
            onSearchSite={searchSite}
            searchSitedata={searchSitedata}
            divisionId={divisionId}
            deleteSWProject={deleteSWProject}
            shouldRestoreState={shouldRestoreState}
          />
          <ToastContainer />
        </>
      ) : (
        navigate(ACCESS_DENIED)
      )}
    </>
  );
}

export default SwProjectListContainer;
